import React from 'react';
import { cn } from '@/lib/utils';

export interface TagOption {
  id: string;
  label: string;
  emoji: string;
}

interface TagSelectorProps {
  selected: string[];
  onChange: (tags: string[]) => void;
}

const TAG_OPTIONS: TagOption[] = [
  { id: 'spicy', label: 'Spicy', emoji: '🔥' },
  { id: 'healthy', label: 'Healthy', emoji: '🌿' },
  { id: 'hidden_gem', label: 'Hidden Gem', emoji: '💎' },
  { id: 'good_value', label: 'Good Value', emoji: '💰' },
  { id: 'insta_worthy', label: 'Insta-Worthy', emoji: '📸' },
  { id: 'great_leftovers', label: 'Great Leftovers', emoji: '🥡' },
  { id: 'authentic', label: 'Authentic', emoji: '🧑‍🍳' },
  { id: 'comfort_food', label: 'Comfort Food', emoji: '☁️' },
];

export const TagSelector: React.FC<TagSelectorProps> = ({ selected, onChange }) => {
  const toggleTag = (tagId: string) => {
    if (selected.includes(tagId)) {
      onChange(selected.filter(id => id !== tagId));
    } else {
      onChange([...selected, tagId]);
    }
  };

  return (
    <div className="space-y-3 p-4 rounded-xl bg-muted/30 border border-border">
      <div className="text-center">
        <h3 className="text-base font-semibold text-foreground">Add Tags</h3>
        <p className="text-xs text-muted-foreground">What vibes does this dish give?</p>
      </div>

      <div className="flex flex-wrap gap-2 justify-center">
        {TAG_OPTIONS.map((tag) => {
          const isSelected = selected.includes(tag.id);
          return (
            <button
              key={tag.id}
              type="button"
              onClick={() => toggleTag(tag.id)}
              className={cn(
                "flex items-center gap-1.5 px-3 py-2 rounded-full border text-sm font-medium transition-all duration-200",
                "min-h-[40px] touch-manipulation",
                isSelected
                  ? "bg-[#cfef00] border-[#cfef00] text-black shadow-md scale-105"
                  : "bg-background border-border text-muted-foreground hover:border-[#cfef00]/50 hover:bg-[#cfef00]/10"
              )}
            >
              <span>{tag.emoji}</span>
              <span>{tag.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default TagSelector;
